class CreatePasswordController {
    static $inject = ["$location", "stToast", "tpsrService"];

    constructor($location, stToast, tpsrService) {
        this.$location = $location;
        this.toast = stToast;
        this.tpsr = tpsrService;

        this.password1 = null;
        this.password2 = null;
        this.loading = false;
        this.saving = false;
        this.badKey = false;
        this.validKey = false;
        this.reason = null;
        this.reasons = [];
        this.email = null;
        this.user_id = null;
        this.is_existing_user = false;
        this.badPassword = false;
    }

    $onInit() {
        if (!this.key) {
            this.reason = "URL is missing key.";
            this.badKey = true;
        } else {
            this.loading = true;
            this.tpsr.getUserForCreatePassword(this.key)
                .then(result => {
                    if (result.is_valid) {
                        this.user_id = result.user_id;
                        this.email = result.email;
                        this.is_existing_user = result.is_existing_user;
                        this.validKey = true;
                    } else {
                        this.reason = result.reason;
                        this.badKey = true;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }

    canSavePassword = () => {
        if (this.saving)
            return false;
        if (!this.password1)
            return false;
        if (!this.password2)
            return false;
        if (this.password1 !== this.password2)
            return false;;
        return true;
    };

    savePasswordClicked = () => {
        this.badPassword = false;
        this.reasons.length = 0;
        this.saving = true;
        this.tpsr.updateUserPasswordFromKey(this.key, this.password1)
            .then(result => {
                if (result.is_valid) {
                    this.toast.success("Password Saved", "Your account is now ready!");
                    this.$location.url("/");
                } else {
                    this.reasons = result.reasons;
                    this.badPassword = true;
                }
            })
            .finally(() => {
                this.saving = false;
            });
    };
}

angular
    .module("app")
    .component("createPassword", { // create-password
        bindings: {
            key: "<"
        },
        templateUrl: "src/app/account/createPassword/createPassword.html",
        controller: CreatePasswordController
    });
